import React, { useMemo } from 'react';
import FormSelect from './FormSelect';
import FormTextarea from './FormTextarea';
import { IL_ADLARI, ilceleriGetir } from './data/illerIlceler';

const StepAddress = ({ formData, handleInputChange, onIlChange }) => {
  // Liste uygulama içine gömülü; sunucuya istek atılmaz.
  const iller = useMemo(
    () => IL_ADLARI.map(ad => ({ value: ad, label: ad })),
    []
  );

  const ilceler = useMemo(
    () => ilceleriGetir(formData.il).map(ad => ({ value: ad, label: ad })),
    [formData.il]
  );

  return (
    <div className="animate-fadeIn">
      <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">
        Adres Bilgileri
      </h2>
      <p className="text-gray-600 mb-8">
        İkamet adresinizi detaylı bir şekilde belirtiniz. İl, ilçe ve açık adres alanlarının tamamı zorunludur.
      </p>

      <FormSelect
        label="İl"
        name="il"
        value={formData.il}
        onChange={(e) => onIlChange(e.target.value)}
        options={iller}
        placeholder="İl seçiniz"
        required
      />

      <FormSelect
        label="İlçe"
        name="ilce"
        value={formData.ilce}
        onChange={handleInputChange}
        options={ilceler}
        placeholder="İlçe seçiniz"
        disabled={!formData.il}
        emptyText="Önce il seçiniz"
        required
      />

      <FormTextarea
        label="Açık Adres"
        name="address"
        value={formData.address}
        onChange={handleInputChange}
        placeholder="Mahalle, cadde/sokak, bina no ve daire no bilgilerini içerecek şekilde giriniz"
        required
        rows={5}
      />

      <div className="mt-6 p-4 bg-white border-2 border-primary rounded-lg">
        <div className="flex">
          <svg className="h-5 w-5 text-primary flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <p className="ml-3 text-sm text-primary font-medium">
            Adres bilgileriniz beyanınıza göre kaydedilir; MERNİS adres sorgusu yapılmaz.
            Başvurunun değerlendirilmesinde beyan ettiğiniz adres esas alınacağından bilgileri doğru girdiğinizden emin olunuz.
          </p>
        </div>
      </div>
    </div>
  );
};

export default StepAddress;
